/** Layout props shared by hero carousel `<Image>` and server `getImageProps` / `preload`.
 * 4:3 landscape aspect ratio for hero images
 */
export const heroCarouselImageLayout = {
  width: 800,
  height: 600,
  sizes: "(max-width: 1024px) 100vw, 60vw",
  quality: 70,
} as const;
